import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DraggableDirective } from './common/draggable.directive';

import { SplitterComponent } from './splitter/splitter.component';
import { SplitterBarComponent } from './splitter/splitter-bar.component';
import { SplitterPaneComponent } from './splitter/splitter-pane.component';

const exportedModules = [SplitterComponent, SplitterPaneComponent];

const declarations = [DraggableDirective, SplitterBarComponent, ...exportedModules];

/**
 * Represents the [NgModule](https://angular.io/docs/ts/latest/guide/ngmodule.html)
 * definition for the Splitter component.
 *
 * The module registers:
 * - `SplitterComponent`&mdash;The `Splitter` component class.
 * - `SplitterPaneComponent`&mdash;The `SplitterPane` component class.
 */
@NgModule({
  declarations: [declarations],
  exports: [exportedModules],
  imports: [CommonModule],
})
export class SplitterModule {}
